var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 13.3501C15.1044 13.3501 15.9998 12.4547 15.9998 11.3501C15.9998 10.2456 15.1044 9.35015 13.9998 9.35015C12.8953 9.35015 11.9998 10.2456 11.9998 11.3501C11.9998 12.4547 12.8953 13.3501 13.9998 13.3501Z",
    fill: "#403B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 20.0168C12.4377 20.0168 13.3332 19.1214 13.3332 18.0168C13.3332 16.9122 12.4377 16.0168 11.3332 16.0168C10.2286 16.0168 9.33317 16.9122 9.33317 18.0168C9.33317 19.1214 10.2286 20.0168 11.3332 20.0168Z",
    fill: "#403B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 21.3501C20.7362 21.3501 21.3332 20.7532 21.3332 20.0168C21.3332 19.2804 20.7362 18.6835 19.9998 18.6835C19.2635 18.6835 18.6665 19.2804 18.6665 20.0168C18.6665 20.7532 19.2635 21.3501 19.9998 21.3501Z",
    fill: "#403B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2665 14.6701C26.8798 14.6301 24.3332 12.0701 25.6932 9.04348C21.7332 10.3768 17.9865 6.92348 18.7732 2.96348C9.47984 1.00348 2.6665 8.56348 2.6665 16.0168C2.6665 23.3768 8.63984 29.3501 15.9998 29.3501C23.8532 29.3501 30.0532 22.5768 29.2665 14.6701ZM15.9998 26.6835C10.1198 26.6835 5.33317 21.8968 5.33317 16.0168C5.33317 11.6035 8.97317 5.11015 16.1065 5.32348C16.6665 8.71015 19.3598 11.4035 22.7598 11.9101C22.8532 12.3901 23.4532 15.3101 26.6532 16.7501C26.2665 22.4968 21.4132 26.6835 15.9998 26.6835Z",
    fill: "#403B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.c967ff2d144e35fd59bf62400103ebea.svg";
export { ForwardRef as ReactComponent };